<template>
    <app-layout>
        <Head>
            <title>Bauteil</title>
        </Head>

        <template v-slot:intronav>
            <div class="row">
                <div class="col col-4">
                    <form-button icon="cursor-swipe-left" color="primary" dense="true" @click="stepBack" :disabled="isFirst"/>
                    <form-button icon="cursor-swipe-up" color="primary" dense="true" @click="stepOverview"/>
                    <form-button icon="cursor-swipe-right" color="primary" dense="true" @click="stepNext" :disabled="isLast"/>
                </div>
            </div>
        </template>

        <div class="producer-quote">
            <div class="row">
                <div class="col col-4">
                    <div class="row">
                        <div class="col">
                            <component-sidebar-sketch :ask-for-quote="askForQuote" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <component-sidebar-inquiry :ask-for-quote="askForQuote" :abilities="abilities" />
                        </div>
                    </div>
                </div>
                <div class="col col-8">
                    <component-order :producer-order="askForQuote.producer_order" v-if="hasProducerOrder" />
                    <component-offer :ask-for-quote="askForQuote" v-if="!hasProducerOrder" />
                    <component-offer-table :ask-for-quote="askForQuote" v-if="hasProducerOrder" />
                </div>
            </div>
        </div>

    </app-layout>
</template>

<script>
import AppLayout from '@partfactory/Layouts/AppLayout';
import ComponentSidebarSketch from '@partfactory/Pages/Producer/Component/ComponentSidebarSketch';
import ComponentSidebarInquiry from '@partfactory/Pages/Producer/Component/ComponentSidebarInquiry';
import ComponentOffer from '@partfactory/Pages/Producer/Component/ComponentOffer';
import ComponentOrder from '@partfactory/Pages/Producer/Component/ComponentOrder';
import ComponentOfferTable from '@partfactory/Pages/Producer/Component/ComponentOfferTable';
import FormButton from '@partfactory/Shared/Form/FormButton';

export default {
    name: 'Component',
    components: {
        FormButton,
        ComponentOfferTable,
        ComponentOrder,
        ComponentOffer,
        ComponentSidebarInquiry,
        ComponentSidebarSketch,
        AppLayout
    },
    props: [
        'askForQuote',
        'abilities',
    ],
    computed: {
        hasProducerOrder() {
            return !!this.askForQuote.producer_order;
        },
        isFirst() {
            return !! this.$page.props.errors.back;
        },
        isLast() {
            return !! this.$page.props.errors.next;
        },
    },
    methods: {
        stepBack() {
            this.$inertia.visit(this.$$route('component.back', {'askForQuote': this.askForQuote}));
        },
        stepNext() {
            this.$inertia.visit(this.$$route('component.next', {'askForQuote': this.askForQuote}));
        },
        stepOverview() {
            this.$inertia.visit(this.$$route('component.overview', {'askForQuote': this.askForQuote}));
        }
    }
};
</script>
